import React, { Fragment, useEffect, useState } from "react";
import { isExpired, decodeToken } from "react-jwt";
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';

import { useStore } from "../../hook-store/store";
import { 
  createLoginExtendToken,
  setLoginExtendToken,
 } from "../../utils/user/user";

import { BACKEND_URL, loginPageLink } from "../../App";

// import { marks } from "../../utils/marks";
// import classes from './GetLoginUsers.module.css';

const LoginUsersTokenUpdate = (props) => {
    const { } = props;

    const [t] = useTranslation('translation');

    const [store, dispatch] = useStore();
    const { 
        isAuth,
        // userNameData,
    } = store.uiStore;


    useEffect(() => {
      if (isAuth) {
        updateLoginUsersTokenHandler();
        updateCurrentUserTokenHandler();
      }
    },[isAuth]);


    const updateLoginUsersTokenHandler = async () => {
      try {
        const lsLoginUserList = localStorage.getItem('loginUserList');
        
        if (!lsLoginUserList) {
          return
        }

        const parsedTokenList = JSON.parse(lsLoginUserList);

        if (!(parsedTokenList.length > 0)) {
          return;
        }

        for (const tokenData of parsedTokenList) {

          //// skip current page login user
          if (tokenData.email === localStorage.getItem('email')) {
            continue;
          }

          const decodedLastExpToken = decodeToken(tokenData.lastExpToken);
          // console.log(decodedLastExpToken);

          //// skip recently updated user
          const after7daysIssueTime = decodedLastExpToken.iat*1000 + 1000*60*60*24*7;
          // const after7daysIssueTime = decodedLastExpToken.iat*1000;
          
          const tokenExpireTime = decodedLastExpToken.exp*1000;

          if (Date.now() < after7daysIssueTime || Date.now() > tokenExpireTime) {
            continue;
          }

          const resData = await createLoginExtendToken(
            BACKEND_URL,
            tokenData.lastExpToken,
            decodedLastExpToken.userId,
          );
          // console.log(resData);

          if (resData && resData.data && resData.data.lastLoginToken && 
              resData.data.loginExtendToken
          ) {
            const decodedExtendToken = decodeToken(resData.data.loginExtendToken);
            // console.log(decodedExtendToken);

            //// update lsLoginUserList
            const withoutUserList = parsedTokenList.filter(ele => {
              return ele.email !== decodedExtendToken.email;
            });

            const newList = withoutUserList.concat({
              email: decodedExtendToken.email,
              lastLoginToken: resData.data.lastLoginToken,
              loginExtendToken: resData.data.loginExtendToken,
              lastExpToken: resData.data.loginExtendToken,
            });
            
            // console.log(newList);
            localStorage.setItem('loginUserList', JSON.stringify(newList));

            // console.log('loginUserList tokendata updated', decodedExtendToken.email)
          }

        }

      } catch(err) {
        console.log(err);
        throw err;
      }
    };



    const updateCurrentUserTokenHandler = async () => {
      try {
        const lsLoginUserList = localStorage.getItem('loginUserList');
        
        if (!lsLoginUserList) {
          return
        }

        const parsedTokenList = JSON.parse(lsLoginUserList);

        if (!(parsedTokenList.length > 0)) {
          return;
        }

        const lsTokenDecoded = decodeToken(localStorage.getItem('token'));
        console.log('lsTokenDecoded', lsTokenDecoded);

        const after7daysIssueTime = lsTokenDecoded.iat*1000 + 1000*60*60*24*7;
        // const after7daysIssueTime = lsTokenDecoded.iat*1000;
        
        const tokenExpireTime = lsTokenDecoded.exp*1000;

        if (Date.now() < after7daysIssueTime || Date.now() > tokenExpireTime) {
          return;
        }


        const resData = await createLoginExtendToken(
          BACKEND_URL,
          localStorage.getItem('token'),
          localStorage.getItem('userId'),
        );
        console.log(resData);

        if (resData && resData.data && resData.data.lastLoginToken && 
            resData.data.loginExtendToken
        ) {

          //// update localStorage token data
          setLoginExtendToken(resData.data.loginExtendToken);
          // console.log('current loginuser ls token updated', localStorage.getItem('email'))
          // console.log('current loginuser ls token updated token', resData.data.loginExtendToken)


          //// update loginUserList in localStorage
          const decodedExtendToken = decodeToken(resData.data.loginExtendToken);
          // console.log(decodedExtendToken);

          const withoutUserList = parsedTokenList.filter(ele => {
            return ele.email !== decodedExtendToken.email;
          });

          const newList = withoutUserList.concat({
            email: decodedExtendToken.email,
            lastLoginToken: resData.data.lastLoginToken,
            loginExtendToken: resData.data.loginExtendToken,
            lastExpToken: resData.data.loginExtendToken,
          });
          
          // console.log(newList);
          localStorage.setItem('loginUserList', JSON.stringify(newList));
          // console.log('current login user loginUserList token data updated', decodedExtendToken.email)
          // console.log('current login user loginUserList token data updated token ', resData.data.loginExtendToken)
        }

      } catch(err) {
        console.log(err);
        throw err;
      }
    };











  return (<Fragment></Fragment>);
};

export default LoginUsersTokenUpdate;
